export default __webpack_public_path__ + "static/media/search-icon.6e70650f.svg";